"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _Thumbs = _interopRequireDefault(require("./components/Thumbs/Thumbs"));

var ReactDropZone = function ReactDropZone(_ref) {
  var acceptFileTypes = _ref.acceptFileTypes,
      _onDrop = _ref.onDrop,
      field = _ref.field;

  var _useState = (0, _react.useState)({
    files: []
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
    onDrop: function onDrop(acceptedFiles, rejectedFiles) {
      return _onDrop(acceptedFiles, rejectedFiles, field, setState);
    },
    accept: acceptFileTypes.join(', '),
    "data-testid": "DropzoneInput"
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
        getInputProps = _ref2.getInputProps;
    return /*#__PURE__*/_react.default.createElement("div", getRootProps(), /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle1"
    }, "Drag 'n' drop some files here, or click to select files"), /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
      files: state.files
    }));
  });
};

var _default = ReactDropZone;
exports.default = _default;
ReactDropZone.propTypes = {
  acceptFileTypes: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * callBack function to set Thumbs to files state and bind data to rff
   */
  onDrop: _propTypes.default.func,

  /**
   * rff field
   */
  field: _propTypes.default.shape({
    input: _propTypes.default.shape({
      onChange: _propTypes.default.func
    })
  })
};
ReactDropZone.defaultProps = {
  acceptFileTypes: ['image/jpeg', 'image/png', 'application/pdf'],
  field: {},
  onDrop: undefined
};